export const countryMapping: Record<string, string> = {
    DK: 'Denmark',
    SE: 'Sweden',
    NO: 'Norway',
    FI: 'Finland',
    DE: 'Germany',
    ES: 'Spain',
    GB: 'United Kingdom'
  };